module.exports = __webpack_public_path__ + "static/walmart_comps-890155b24e2a6bd52d7b36fdaeb7ac8d.png";